import { auth0ApiClient } from './auth0ApiClient'

export interface AppNotification {
  id: string
  title: string
  body: string
  category: string
  isRead: boolean
  createdAt: string
}

class NotificationService {
  private readonly baseUrl = '/notifications'

  async getNotifications(): Promise<AppNotification[]> {
    return auth0ApiClient.get<AppNotification[]>(this.baseUrl)
  }

  async markRead(notificationId: string): Promise<AppNotification> {
    return auth0ApiClient.patch<AppNotification>(`${this.baseUrl}/${notificationId}/read`, {})
  }

  async markAllRead(): Promise<{ updated: number }> {
    return auth0ApiClient.patch<{ updated: number }>(`${this.baseUrl}/read-all`, {})
  }
}

export const notificationService = new NotificationService()
